import { render, staticRenderFns } from "./ResourceListSearch.vue?vue&type=template&id=3ebce809&scoped=true"
import script from "./ResourceListSearch.vue?vue&type=script&lang=js"
export * from "./ResourceListSearch.vue?vue&type=script&lang=js"
import style0 from "./ResourceListSearch.vue?vue&type=style&index=0&id=3ebce809&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebce809",
  null
  
)

export default component.exports